export default __webpack_public_path__ + "static/media/home_ghibli_totoro_cry.c39b08a5.jpg";